import { CopyField } from '../../shared/ui/copy-field';
import { DataPanel } from '../../shared/ui/layout';
import { Note } from '../../shared/ui/note';
import { Switch } from '../../shared/ui/switch';
import type { TSource } from '../../entities/source';
import type { IGeneralAddress } from './use-general-address';

export const GeneralAddress = ({
  source,
  address,
  className,
}: {
  source: TSource;
  address: IGeneralAddress;
  className?: string;
}) => {
  const toggle = (
    <Switch
      aria-label="The general address"
      checked={address.open}
      disabled={address.pending}
      onCheckedChange={address.set}
    />
  );

  return (
    <div className={className}>
      {address.open ? (
        <CopyField value={source.ingestUrl} leading={toggle} />
      ) : (
        <DataPanel className="flex items-center gap-inset py-2">
          {toggle}
          <span className="min-w-0 grow">
            <span className="block text-data font-medium text-muted">The general address</span>
            <span className="block font-mono text-meta text-faint">
              closed · answers 404, as an address that does not exist
            </span>
          </span>
        </DataPanel>
      )}

      {address.refusal && (
        <Note tone="danger" className="mt-2">
          {address.refusal}
        </Note>
      )}
    </div>
  );
};
